import React from 'react';
import { useMultiFactorMutation } from '../../../hooks/Auth';
import CenterLayout from '../../vendorlink-views/components/CenterLayout';
import ModalLayout from '../components/ModalLayout';
import { Button, Space } from 'antd';
import ErrorMessage from '../../auth-views/components/ErrorMessage';
import RecaptchaVerifierView from '../../auth-views/components/RecaptchaVerifierView';
import { useProfileQuery } from '../../../hooks/Profile';
import { firstMultiFactor } from '../../../utils/ProfileUtils';
import { Link } from 'react-router-dom';

interface VerifyPhoneNumberStepProps {
  onVerificationCodeSent: (phoneNumber: string, verificationId: string) => void;
  onCancel?: () => void;
}

const VerifyPhoneNumberStep: React.FC<VerifyPhoneNumberStepProps> = ({ onVerificationCodeSent, onCancel }) => {
  const profile = useProfileQuery().data;
  const multiFactor = firstMultiFactor(profile);
  const { useVerifyMultiFactor } = useMultiFactorMutation();
  if (!multiFactor) {
    return <></>;
  }
  const onSubmitSubmit = async () => {
    const phoneNumber = multiFactor.phoneNumber;
    const response = await useVerifyMultiFactor.mutateAsync({ phoneNumber: phoneNumber });
    onVerificationCodeSent(phoneNumber, response.verificationId);
  };
  return (
    <CenterLayout>
      <ModalLayout
        header={
          <Space direction="vertical">
            <div className="heading-xs">Verification code required for access</div>
            <div className="text-content-secondary">
              The page you're trying to access contains important information. In order to keep your account secure from
              any unauthorized access, we require you to enter a verification code that is sent to your phone number{' '}
              <b>{multiFactor.phoneNumber}</b>.
            </div>
          </Space>
        }
        content={
          <>
            <ErrorMessage />
          </>
        }
        footer={
          <>
            <Space>
              <Button disabled={useVerifyMultiFactor.isLoading} onClick={onSubmitSubmit} type="primary">
                Send verification code
              </Button>
              {onCancel && (
                <Button onClick={onCancel} type="text">
                  Cancel
                </Button>
              )}
            </Space>
            <Link to="#" onClick={() => Intercom('show')}>
              <b>I need help</b>
            </Link>
          </>
        }
      />
      <RecaptchaVerifierView />
    </CenterLayout>
  );
};

export default VerifyPhoneNumberStep;
